// A journal day is the patient's calendar day, YYYY-MM-DD on their own clock.
// Not toISOString(): that is the UTC day, so in Canada an entry written in the
// evening landed on tomorrow, and a day picked from the list on yesterday.

const pad = (n) => String(n).padStart(2, "0");

export function localDay(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function previousLocalDay(date) {
  const before = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
  return localDay(before);
}
